import { EULAprops } from '@usacsmideo/types';

export const EULASectionHeader = (props: EULAprops) => {
  return <h3 className="text-sm font-semibold">{props.text}</h3>;
};
